import {format, parseISO} from "date-fns";
import {pl} from "date-fns/locale";


/**
 * @param {string|Date} date
 * @param {string} formatString
 * @returns {*}
 */
export const formatDate = (date, formatString = 'P') => {
    if (date === '' || date === null || date === void 0) {
        return '';
    }
    if (typeof date === 'string') {
        date = parseISO(date);
    }
    return format(date, formatString, {locale: pl});
};
